import { render, staticRenderFns } from "./ShiftProgram.vue?vue&type=template&id=a768ac8a&lang=pug&"
import script from "./ShiftProgram.vue?vue&type=script&lang=js&"
export * from "./ShiftProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports